export function urlSafeEncode(str) {
  return str.split('').map(function (_char) {
    return _char.charCodeAt(0).toString(16).padStart(2, '0');
  }).join('');
}
export function urlSafeDecode(hex) {
  return hex.match(/.{2}/g).map(function (_char2) {
    return String.fromCharCode(parseInt(_char2, 16));
  }).join('');
}